<template>
  <div class="dropdown dropdown-inline">
    <button type="button" @click="$emit('export')" class="btn btn-light-primary font-weight-bolder mr-2">
      <span class="svg-icon svg-icon-md"><i class="el-icon-download"></i></span>Xuất excel
    </button>
    <button type="button" @click="$emit('classify')" class="btn btn-light-info font-weight-bolder mr-2">
      <i class="fa fa-tags mr-1"></i> Phân loại giảng viên
    </button>
    <button type="button" @click="$emit('create')" class="btn btn-light-success font-weight-bolder mr-2">
      <i class="fa fa-plus mr-1"></i> Thêm mới
    </button>
  </div>
  
</template>

<script>
export default { name: 'ActionBar' };
</script>

<style scoped>
</style>


